import React from 'react';
// Import image directly using ES import
import nDSMImage from '../../../assets/images/nDSM.png';

const DEMGeneration = () => {
    return (
        <div className="analysis-section">
            <div className="analysis-content">
                <h2>Digital Elevation Models (DEM)</h2>
                <p>
                    Our high-precision Digital Elevation Model (DEM) services transform raw LiDAR point clouds into accurate, detailed terrain representations essential for infrastructure planning, hydrological analysis, and environmental management.
                </p>
                <p>
                    With centimeter-level vertical accuracy, our DEMs provide the foundation for confident decision-making in engineering, construction, and natural resource management. We deliver custom-tailored elevation models optimized for your specific application needs, whether for flood modeling, road design, or precision agriculture.
                </p>
                <p>
                    Our advanced filtering algorithms effectively separate ground returns from vegetation and built structures, ensuring a true bare-earth model that reveals the underlying terrain with remarkable clarity—even in densely vegetated or complex urban environments.
                </p>
                <div className="analysis-features">
                    <span className="feature-item">Bare Earth Models</span>
                    <span className="feature-item">Surface Models</span>
                    <span className="feature-item">Terrain Analysis</span>
                    <span className="feature-item">Contour Generation</span>
                    <span className="feature-item">Watershed Mapping</span>
                </div>
            </div>
            <div className="analysis-image">
                <img src={nDSMImage} alt="Normalized Digital Surface Model (nDSM) of Urban Area" />
            </div>
        </div>
    );
};

export default DEMGeneration;